<p-dialog *ngIf="displayContact" [(visible)]="displayContact"  [responsive]="true" [blockScroll]="false" [modal]="true"  
  [closable]="false" [style]="{width: '80vw'}">
  <ng-template pTemplate="header">
    <div style="display: flex; justify-content: space-between; width: 100%;">
        <h5 class="p-mb-0">
          {{contactModalHeader}}
        </h5>
        <div class="p-ml-auto p-d-flex p-ai-center">
            <div *ngIf="mode == 'view'" class="p-mr-2">
                <strong> Created by {{ contactEditDetails?.createdByUserName }}</strong> {{ contactEditDetails?.createdDate | localDate: 'date' }}
            </div>
        </div>
    </div>
</ng-template>
  <ng-container *ngIf="contactForm && inputDataCheck">
    <form [formGroup]="contactForm" novalidate>
      <div class="header">
        <h5>
          {{ templateSections?.[0]?.name||'Contact Information'}}
          <p-inputSwitch formControlName="isActive" class="header-switch" [disabled]="crudType=='view'"
            (onChange)="changeStatus($event)"></p-inputSwitch>
        </h5>
      </div>

      <div class="card">
        <div class="p-grid">
          <div *ngIf="inputDataCheck.contactType?.enabledInForm" class="p-col-12 p-md-6">
            <label>{{inputDataCheck.contactType?.labelName}} <span *ngIf="inputDataCheck.contactType?.isRequired"  class="required-sign">*</span></label>
            <p-dropdown [options]="contactTypes" optionLabel="name" optionValue="value" formControlName="contactType" [filter]="true"
              [autoDisplayFirst]="false" placeholder="Contact Type" appendTo="body">
            </p-dropdown>
            <div *ngIf="contactForm.get('contactType').invalid && contactForm.get('contactType').touched"
              class="p-invalid">
              <small>Please select a Contact Type</small>
            </div>
          </div>
        </div>

        <!-- Contact Name and Contact Association Row -->
        <div class="p-grid">
          <div *ngIf="inputDataCheck.contactAssociation?.enabledInForm" class="p-col-12 p-md-6">
            <label>{{inputDataCheck.contactAssociation?.labelName}}<span *ngIf="inputDataCheck.contactAssociation?.isRequired"  class="required-sign">*</span></label>
            <p-dropdown [options]="contactAssociations" formControlName="contactAssociation" 
              optionLabel="name" placeholder="Contact Association" (onChange)="changeAssociation($event)" appendTo="body">
            </p-dropdown>
            <div *ngIf="contactForm.get('contactAssociation').invalid && contactForm.get('contactAssociation').touched"
              class="p-invalid">
              <small>Please select a contactAssociation</small>
            </div>
          </div>
          <div *ngIf="inputDataCheck.businessName?.enabledInForm" class="p-col-12 p-md-6">
            <label>{{ inputDataCheck.businessName?.labelName }} <span *ngIf="inputDataCheck.businessName?.isRequired"  class="required-sign">*</span></label>
             <p-autoComplete  *ngIf="associationTypeName != 'account' && associationTypeName != 'lead'" formControlName="businessName"
              [suggestions]="filteredBusinessNames"
              (completeMethod)="onBusinessNameChange($event.query)"
              [forceSelection]="true"
              [dropdown]="false"
              [minLength]="1"
              field="name"
              placeholder="Search Business Name">
            </p-autoComplete>
            <ng-container *ngIf="associationTypeName == 'account' || associationTypeName == 'lead'">
            <span *ngIf="!contactForm?.get('businessName').value?.businessName && (associationTypeName == 'account' || associationTypeName == 'lead')" (click)="!isAssociationName && openParentAcountDialog('new')" class="hyper-link"><strong  c class="association-name"><i class="pi pi-plus p-mr-2"></i> Select {{ inputDataCheck.businessName?.labelName}}</strong></span>
              <span  *ngIf="contactForm?.get('businessName')?.value" class="hyper-link">
                <strong class="association-name" [ngClass]="{'disabled-icon': isAssociationName}" (click)="!isAssociationName && openParentAcountDialog('edit')">
                  @if(contactForm?.get('businessName').value?.businessName && !isAssociationName){
                    <i  class="pi pi-pencil p-mr-2"></i> 
                 }
                    <ng-container >
                        {{ contactForm?.get('businessName').value?.businessName }}
                    </ng-container>
                </strong>
                @if(contactForm?.get('businessName').value?.businessName && !isAssociationName){
                  <strong (click)="!isAssociationName && removeParentAccount()" [ngClass]="{'disabled-icon': isAssociationName}"> 
                      <i  class="pi pi-times p-ml-3"></i>
                   </strong>
              }
                
            </span>
          </ng-container>
            <div *ngIf="contactForm.get('businessName').invalid && contactForm.get('businessName').touched"
              class="p-invalid">
              <small>Please select a business name</small>
            </div>
          </div>
        </div>

        <!-- Title, First Name, Middle Name, Last Name Row -->
        <div class="p-grid">
          <div *ngIf="inputDataCheck.title?.enabledInForm" class="p-col-12 p-md-3">
            <label>{{ inputDataCheck.title?.labelName }} <span *ngIf="inputDataCheck.title?.isRequired"  class="required-sign">*</span> </label>
            <p-dropdown [options]="titles" formControlName="title" optionLabel="name" optionValue="id" placeholder="Select Title" [filter]="true"
              appendTo="body">
            </p-dropdown>
            <div *ngIf="contactForm.get('title').invalid && contactForm.get('title').touched"
              class="p-invalid">
              <small>Please select a title</small>
            </div>
          </div>

          <div *ngIf="inputDataCheck?.firstName?.enabledInForm" class="p-col-12 p-md-3">
            <label>{{ inputDataCheck?.firstName?.labelName }} <span *ngIf="inputDataCheck.firstName?.isRequired"  class="required-sign">*</span> </label>
            <input pInputText type="text" formControlName="firstName" name="firstName">
            <div *ngIf="contactForm.get('firstName').invalid && contactForm.get('firstName').touched"
              class="p-invalid">
              <small>Please add a firstName</small>
          </div>
          </div>

          <div *ngIf="inputDataCheck.middleName?.enabledInForm" class="p-col-12 p-md-3">
            <label>{{ inputDataCheck.middleName?.labelName }}  <span *ngIf="inputDataCheck.middleName?.isRequired"  class="required-sign">*</span>  </label>
            <input pInputText type="text" formControlName="middleName" name="middleName">
            <div *ngIf="contactForm.get('middleName').invalid && contactForm.get('middleName').touched"
              class="p-invalid">
              <small>Please add a middleName</small>
          </div>
          </div>

          <div *ngIf="inputDataCheck.lastName?.enabledInForm" class="p-col-12 p-md-3">
            <label>{{ inputDataCheck.lastName?.labelName }}<span *ngIf="inputDataCheck.lastName?.isRequired"  class="required-sign">*</span> </label>
            <input pInputText type="text" formControlName="lastName" name="lastName">
            <div *ngIf="contactForm.get('lastName').invalid && contactForm.get('lastName').touched"
              class="p-invalid">
              <small>Please add a lastName</small>
          </div>
          </div>
        </div>

         <div class="p-col-12 p-lg-12" class="p-grid">
          <!-- Row 2: Social email Section -->
        <div *ngIf="inputDataCheck.email?.enabledInForm && inputDataCheck?.email?.childFields?.length" class="p-col-4 p-lg-4" >
          <label>{{inputDataCheck.email?.labelName}} <span *ngIf="inputDataCheck.email?.isRequired"  class="required-sign">*</span></label>
          <div formArrayName="additionalEmails">
            <div *ngFor="let email of additionalEmails.controls; let i = index" [formGroupName]="i" class="p-grid">
              <div class="p-col-12">
                <div class="p-inputgroup">
                  <span class="p-inputgroup-addon">
                    <i [pTooltip]="email.get('label')?.value"  tooltipPosition="top" class="pi"      [ngClass]="{
                      'pi-briefcase': email.get('label')?.value === 'Work Email',
                      'pi-home': email.get('label')?.value === 'Home Email',
                      'pi-envelope': email.get('label')?.value.startsWith('CE')
                    }"></i>
                  </span>
                  <input  pInputText type="text" name="email" formControlName="emailAddress" 
                  pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$" 
                  email 
                  (blur)="checkEmailValidity(i)">
                  <button *ngIf="i === 0" pButton type="button" [disabled]="mode == 'view'" icon="pi pi-plus" (click)="addEmailField()"
                    [disabled]="mode == 'view' || additionalEmails?.length === 4 || additionalEmails?.length == inputDataCheck?.email?.childFields?.length"></button>
                  <button *ngIf="i !== 0" [disabled]="mode == 'view'" pButton type="button" icon="pi pi-times" (click)="removeEmailField(i)"></button>
                </div>
                <div *ngIf="email.get('emailAddress')?.invalid && email.get('emailAddress')?.touched">
                  <small class="required-sign">
                    {{ getEmailErrors(email.get('emailAddress')) }} 
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Row 2: Social Profile Section -->
        <div *ngIf="inputDataCheck.social?.enabledInForm && inputDataCheck?.social?.childFields?.length"  class="p-col-4 p-lg-4">
          <label>{{ inputDataCheck.social?.labelName }} <span *ngIf="inputDataCheck.social?.isRequired"  class="required-sign">*</span> </label>
          <div formArrayName="additionalSocialProfile">
            <div *ngFor="let social of additionalSocialProfile.controls; let n = index" [formGroupName]="n" class="p-grid">
              <div class="p-col-12">
                <div class="p-inputgroup">
                  <span class="p-inputgroup-addon">
                    <i class="fa" [ngClass]="socialProfiles[n]" pTooltip="{{ (socialProfiles[n] === 'fa-laptop' ? 'fa-website' : socialProfiles[n]) | slice:3 | titlecase }}"></i>
                  </span>
                  <input  type="text" pInputText formControlName="socialProfile" (blur)="social.get('socialProfile')?.markAsTouched()" >
                  <button *ngIf="n == 0" pButton type="button"  icon="pi pi-plus" (click)="addSocialField()" [disabled]="mode == 'view' || additionalSocialProfile?.length == 5 || additionalSocialProfile?.length == inputDataCheck?.social?.childFields?.length"></button>
                  <button *ngIf="n != 0" pButton type="button" [disabled]="mode == 'view'"  icon="pi pi-times" (click)="removeSocialProfileField(n)"></button>
                </div>
                <div *ngIf="inputDataCheck.social?.isRequired && isSubmitted && social.get('socialProfile')?.invalid">
                  <small class="required-sign">socialProfile is required</small>
                </div>
              </div>
            </div>
          </div>
        </div>
              <!-- Country Dropdown for additional phone -->
          <div  *ngIf="inputDataCheck.phone?.enabledInForm && inputDataCheck?.phone?.childFields?.length"  formArrayName="additionalPhones" class="p-col-4 p-lg-4">
            <div *ngFor="let phone of contactForm.get('additionalPhones').controls; let m = index" [formGroupName]="m" class="p-grid">
              <div class="p-col-6 p-lg-6">
                <label> Select Country <span *ngIf="inputDataCheck.phone?.isRequired"  class="required-sign">*</span></label>
                <!-- Country Dropdown -->
                <p-dropdown 
                  [options]="countryData" 
                  optionLabel="CountryName" 
                  formControlName="country" 
                  (onChange)="onCountryChange($event, m)" 
                  [autoDisplayFirst]="false" [filter]="true"
                  placeholder="Select Country"
                  appendTo="body">
                </p-dropdown>
              </div>
              <!-- additional phone -->
              <div class="p-col-6 p-lg-6">
                <label>{{ phone.value.name }}<span *ngIf="inputDataCheck.phone?.isRequired"  class="required-sign">*</span></label>
                <div class="p-inputgroup">
                  <span class="p-inputgroup-addon">+{{ phone?.value?.phoneCode || countryCode }}</span> 
                  <p-inputMask *ngIf="phoneNumberFormat"  [mask]="phoneNumberFormat" formControlName="number" (blur)="phone?.get('number')?.markAsTouched()"  [autoClear]="false"></p-inputMask>
                  <input *ngIf="!phoneNumberFormat" pInputText onlyNumber pKeyFilter="num"  type="text" formControlName="number" />
                  <button *ngIf="m == 0"  pButton type="button" icon="pi pi-plus" (click)="addPhoneField()"
                [disabled]="mode == 'view' || additionalPhones?.length == 5 || additionalPhones?.length == inputDataCheck?.phone?.childFields?.length"></button>
                  <button *ngIf="m != 0" pButton type="button" [disabled]="mode == 'view'" icon="pi pi-times" (click)="removePhoneField(m)"></button>
                </div>
                <div *ngIf="inputDataCheck.phone?.isRequired && isSubmitted && phone.get('number')?.invalid" 
              class="p-invalid">
                <small>Please select a number </small>
            </div>
              </div>
            </div>
          </div>
          </div>

     <!-- Image section-->
      <div *ngIf="inputDataCheck.profileImage?.enabledInForm" class="p-field p-formgrid p-grid">
        <div class="p-col-12 p-lg-6">
            <label>{{ inputDataCheck.profileImage?.labelName }}<span *ngIf="inputDataCheck.profileImage?.isRequired"  class="required-sign">*</span> </label>
            <p-fileUpload #fileInput name="myfile[]" customUpload="true" [disabled]="mode == 'view'"
                (onSelect)="onUpload($event.files)" [showUploadButton]="false" multiple="multiple"
                accept="image/*" maxFileSize="10000000" (onRemove)="removeImage($event.file)">
                <ng-template pTemplate="content">
                    <ng-container *ngIf="contactProfileImages?.length">
                        <ng-container *ngFor="let file of contactProfileImages;let i=index">
                            <div *ngIf="file?.attachment && file?.attachment?.statusId != 3" class="p-fileupload-row">
                                <button *ngIf="file?.id" type="button" pButton icon="fa fa-download"
                                    (click)="downloadFile(file.attachment?.downloadLink)"
                                    class="p-button-link p-px-0 p-py-0" label=""></button>
                                <ng-container *ngIf="file?.contactId">
                                    <img [src]="file?.attachment?.downloadLink" class="imagePreview"> 
                                     {{ file?.attachment?.name?.substring(0, 14)
                                    }}
                                </ng-container>
                                <ng-container *ngIf="file?.id">{{ (file.attachment?.sizeInBytes / 1024).toFixed(2) + ' KB' }}</ng-container>
                                <div>
                                    <button *ngIf="file?.id" icon="pi pi-times" pButton [disabled]="mode == 'view'"
                                        (click)="deleteImage(file?.id)" type="button"
                                        >
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-template>
            </p-fileUpload>
        </div>
    </div>


        <!-- Show more section Row -->
        <div class="p-text-right">
          <button type="button" style="margin: 10px 0;" pButton (click)="showAddMore= !showAddMore"
            label="{{showAddMore ? 'Show Less' : 'Show More'}}" class="p-button-secondary"></button>
        </div>
        <div *ngIf="showAddMore">
          <!-- Gender and Relateion selection field -->
          <div class="p-grid">

            <div *ngIf="inputDataCheck.gender?.enabledInForm" class="p-col-12 p-md-6">
              <label>{{ inputDataCheck.gender?.labelName }} <span *ngIf="inputDataCheck.gender?.isRequired"  class="required-sign">*</span>  </label>
              <p-dropdown [options]="gender" optionLabel="name" formControlName="gender" [autoDisplayFirst]="false"
                placeholder="Gender" appendTo="body">
              </p-dropdown>
              <div *ngIf="contactForm.get('gender').invalid && contactForm.get('gender').touched" class="p-invalid">
                <small>Please select a gender</small>
              </div>
            </div>

            <div *ngIf="inputDataCheck.department?.enabledInForm" class="p-col-12 p-md-6">
              <label>{{ inputDataCheck.department?.labelName }}<span *ngIf="inputDataCheck.department?.isRequired"  class="required-sign">*</span> </label>
              <input pInputText type="text" formControlName="department">
              <div *ngIf="contactForm.get('department').invalid && contactForm.get('department').touched"
                class="p-invalid">
                <small>Please add  Department</small>
              </div>
            </div>
            <div *ngIf="inputDataCheck.birth?.enabledInForm" class="p-col-12 p-md-6">
              <label>{{ inputDataCheck.birth?.labelName }}<span *ngIf="inputDataCheck.birth?.isRequired"  class="required-sign">*</span> </label>
              <p-calendar appendTo="body" [showTime]="false" formControlName="birth"
              [monthNavigator]="true"   [yearNavigator]="true" [maxDate]="maxSelectableDate"  inputId="icon" [hourFormat]="12"  placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"></p-calendar>
              <div *ngIf="contactForm.get('birth').invalid && contactForm.get('birth').touched"
                class="p-invalid">
                 <small>Please select a {{ inputDataCheck.birth?.labelName }}</small>
              </div>
            </div>

            <div *ngIf="inputDataCheck.language?.enabledInForm" class="p-col-12 p-md-6">
              <label>{{ inputDataCheck.language?.labelName }}<span *ngIf="inputDataCheck.language?.isRequired"  class="required-sign">*</span> </label>
              <p-multiSelect [options]="langauge"  formControlName="language" optionLabel="name" placeholder="Select Language ..."  [ngModelOptions]="{standalone: true}">
              </p-multiSelect>
              <div *ngIf="contactForm.get('language').invalid && contactForm.get('language').touched"
                class="p-invalid">
                 <small>Please select a minimum one {{ inputDataCheck.language?.labelName }}</small>
              </div>
            </div>

          </div>
          <!-- Role selection field -->
          <div class="p-grid">

            <div *ngIf="inputDataCheck.startDate?.enabledInForm" class="p-col-12 p-md-6">
              <label>{{ inputDataCheck.startDate?.labelName }}<span *ngIf="inputDataCheck.startDate?.isRequired"  class="required-sign">*</span> </label>
              <p-calendar [maxDate]="today" appendTo="body" [showTime]="false" formControlName="startDate"
              [monthNavigator]="true"   [yearNavigator]="true"  inputId="icon" [hourFormat]="12"  placeholder="mm/dd/yyyy" dateFormat="mm/dd/yy" yearRange="1900:2100"></p-calendar>
              <div *ngIf="contactForm.get('startDate').invalid && contactForm.get('startDate').touched"
                class="p-invalid">
                 <small>Please select a {{ inputDataCheck.startDate?.labelName }}</small>
              </div>
            </div>

            <div *ngIf="inputDataCheck.jobFunction?.enabledInForm" class="p-col-12 p-md-6">
              <label>{{ inputDataCheck.jobFunction?.labelName }}<span *ngIf="inputDataCheck.jobFunction?.isRequired"  class="required-sign">*</span>  </label>
              <p-dropdown [options]="jobFunction" optionLabel="name" formControlName="jobFunction" [filter]="true"
                [autoDisplayFirst]="false" placeholder="Select Designation" appendTo="body">
              </p-dropdown>
              <div *ngIf="contactForm.get('jobFunction').invalid && contactForm.get('jobFunction').touched"
                class="p-invalid">
                <small>Please select a designation</small>
              </div>
            </div>
            <div *ngIf="inputDataCheck.contact_roles?.enabledInForm" class="p-col-12 p-md-6">
              <label>{{ inputDataCheck.contact_roles?.labelName }}<span *ngIf="inputDataCheck.contact_roles?.isRequired"  class="required-sign">*</span>  </label>
              <p-multiSelect [options]="contactRoles" optionLabel="name" formControlName="contactRoles" [filter]="true" dataKey="roleId" optionLabel="roleName" 
                placeholder="Select {{ inputDataCheck.contact_roles?.labelName }}" appendTo="body">
              </p-multiSelect>
              
              <div *ngIf="contactForm.get('contactRoles').invalid && contactForm.get('contactRoles').touched"
                class="p-invalid">
                <small>Please select a role</small>
              </div>
            </div>

            <div *ngIf="inputDataCheck.relation?.enabledInForm" class="p-col-12 p-md-6">
              <label>{{ inputDataCheck.relation?.labelName }}<span *ngIf="inputDataCheck.relation?.isRequired"  class="required-sign">*</span> </label>
              <p-dropdown [options]="relation" optionLabel="name" formControlName="relation" [autoDisplayFirst]="false" [filter]="true"
                placeholder="Select Relation" appendTo="body">
              </p-dropdown>
              <div *ngIf="contactForm.get('relation').invalid && contactForm.get('relation').touched" class="p-invalid">
                <small>Please select a relation</small>
              </div>
            </div>

            <div *ngIf="inputDataCheck.marital?.enabledInForm" class="p-col-12 p-md-6">
              <label>{{ inputDataCheck.marital?.labelName }}<span *ngIf="inputDataCheck.marital?.isRequired"  class="required-sign">*</span> </label>
              <p-dropdown [options]="marital" optionLabel="name" formControlName="marital" [autoDisplayFirst]="false" [filter]="true"
                placeholder="Select Marital Status" appendTo="body">
              </p-dropdown>
              <div *ngIf="contactForm.get('marital').invalid && contactForm.get('marital').touched"
                class="p-invalid">
                 <small>Please select a {{ inputDataCheck.marital?.labelName }} status</small>
              </div>
            </div>

          </div>
          <!-- Annual Income and related field -->
          <div class="p-grid">
            <div *ngIf="inputDataCheck.source?.enabledInForm" class="p-col-12 p-md-6">
              <label>{{ inputDataCheck.source?.labelName }} <span *ngIf="inputDataCheck.source?.isRequired"  class="required-sign">*</span></label>
              <p-dropdown [options]="source" optionLabel="name" formControlName="source" [autoDisplayFirst]="false" [filter]="true"
                placeholder="Select Source" appendTo="body">
              </p-dropdown>
              <div *ngIf="contactForm.get('source').invalid && contactForm.get('source').touched"
                class="p-invalid">
                 <small>Please select a {{ inputDataCheck.source?.labelName }}</small>
              </div>
            </div>

            <div *ngIf="inputDataCheck.income?.enabledInForm" class="p-col-12 p-md-6">
              <label>{{ inputDataCheck.income?.labelName }} <span *ngIf="inputDataCheck.income?.isRequired"  class="required-sign">*</span> </label>
              <p-dropdown [options]="annualIncome" optionLabel="name" formControlName="income" [filter]="true"
                [autoDisplayFirst]="false" placeholder="Select Annual Income" appendTo="body">
              </p-dropdown>
              <div *ngIf="contactForm.get('income').invalid && contactForm.get('income').touched"
                class="p-invalid">
                 <small>Please select a {{ inputDataCheck.income?.labelName }}</small>
              </div>
            </div>

            <div *ngIf="inputDataCheck.degree?.enabledInForm" class="p-col-12 p-md-6">
              <label>{{ inputDataCheck.degree?.labelName }} <span *ngIf="inputDataCheck.degree?.isRequired"  class="required-sign">*</span> </label>
              <p-dropdown [options]="degree" optionLabel="name" formControlName="degree" [autoDisplayFirst]="false" [filter]="true"
                placeholder="Select Degree" appendTo="body">
              </p-dropdown>
              <div *ngIf="contactForm.get('degree').invalid && contactForm.get('degree').touched"
                class="p-invalid">
                 <small>Please select a {{ inputDataCheck.degree?.labelName }}</small>
              </div>
            </div>
          <!-- Feild of Study -->
            <div *ngIf="inputDataCheck.studyField?.enabledInForm" class="p-col-12 p-md-6">
              <label>{{ inputDataCheck.studyField?.labelName }} <span *ngIf="inputDataCheck.studyField?.isRequired"  class="required-sign">*</span></label>
              <p-dropdown [options]="studyField" optionLabel="name" formControlName="studyField" [autoDisplayFirst]="false" [filter]="true"
                placeholder="Select Field of Study" appendTo="body">
              </p-dropdown>
              <div *ngIf="contactForm.get('studyField').invalid && contactForm.get('studyField').touched"
                class="p-invalid">
                 <small>Please select a {{ inputDataCheck.studyField?.labelName }}</small>
              </div>
            </div>

          </div>
          <div class="p-grid">
          <div class="p-col-12 p-lg-6" *ngIf="inputDataCheck.seniority?.enabledInForm">
            <label> {{ inputDataCheck.seniority?.labelName }}<span *ngIf="inputDataCheck.seniority?.isRequired"  class="required-sign">*</span></label>
            <p-autoComplete  #seniorityTo [suggestions]="seniorityList" formControlName="seniority" name="seniorityTo"  
            placeholder="Search by Name ..." field="firstName" [completeOnFocus]="true"
            (completeMethod)="handleCompleteMethod($event , 'seniorityTo')" appendTo="body"
               >
            </p-autoComplete>
            <div *ngIf="contactForm.get('seniority').invalid && contactForm.get('seniority').touched"
                class="p-invalid">
                 <small>Please select a {{ inputDataCheck.seniority?.labelName }}</small>
              </div>
        </div>
        <div *ngIf="inputDataCheck.report?.enabledInForm" class="p-col-12 p-md-6">
            <label>{{ inputDataCheck.report?.labelName }}<span *ngIf="inputDataCheck.report?.isRequired"  class="required-sign">*</span> </label>
            <p-autoComplete  #reportsTo [suggestions]="reportsToList" formControlName="selectedReportsTo"     name="reportsTo"
            placeholder="Search by Name ..." field="firstName" [completeOnFocus]="true"
            (completeMethod)="handleCompleteMethod($event , 'reportsTo')"  id="reportsTo" appendTo="body"
               >
            </p-autoComplete>
            <div *ngIf="contactForm.get('selectedReportsTo').invalid && contactForm.get('selectedReportsTo').touched"
                class="p-invalid">
                 <small>Please select a {{ inputDataCheck.selectedReportsTo?.labelName }}</small>
              </div>
        </div>
        <div class="p-col-12 p-md-6" *ngIf="inputDataCheck.assistant?.enabledInForm">
              <label>{{inputDataCheck.assistant?.labelName}}<span *ngIf="inputDataCheck.assistant?.isRequired"  class="required-sign">*</span> </label>
              <p-autoComplete  #assistantTo [suggestions]="assistantToList" formControlName="selectedAssistant"
               name="assistantTo" placeholder="Search by Name ..." field="firstName"
               [completeOnFocus]="true"
               [forceSelection]="true"
               (completeMethod)="handleCompleteMethod($event , 'assistantTo')" id="assistantTo" appendTo="body"
                  >
              </p-autoComplete>
              <div *ngIf="contactForm.get('selectedAssistant').invalid && contactForm.get('selectedAssistant').touched"
                class="p-invalid">
                 <small>Please select a {{ inputDataCheck.selectedAssistant?.labelName }}</small>
              </div>
        </div>
         <div class="p-col-12 p-lg-6" *ngIf="inputDataCheck.assistant?.enabledInForm">
            <label class="p-inputgroup p-mb-0 p-pb-0">Assistant Phone</label>
            <div class="p-inputgroup p-mt-0 p-pt-0" style="display: flex; align-items: center;">
            <p-dropdown class="p-lg-5 p-mr-4"
                  [options]="countryData" 
                  optionLabel="CountryName" 
                  formControlName="assCountry" 
                  (onChange)="onAsstPhoneCodeChange($event)"
                  [autoDisplayFirst]="false" [filter]="true"
                  placeholder="Select Country"
                  appendTo="body">
                </p-dropdown>
            <span class="p-inputgroup-addon p-mr-0 p-pr-0 p-flex-1" style="height: 100%;" style="height: 100%; display: flex; align-items: center;">+{{contactForm.get('assPhoneCode').value}}</span>
            <p-inputMask class="p-ml-0 p-pl-0 p-flex-1" *ngIf="phoneNumberFormat"  [ngStyle]="phoneNumberFormat ? {'height': '100%'} : {}"  [mask]="phoneNumberFormat" formControlName="assistantPhone" placeholder="Assistant Phone"  [autoClear]="false"></p-inputMask>
            <input class="p-ml-0 p-pl-0 p-flex-1" *ngIf="!phoneNumberFormat" [ngStyle]="!phoneNumberFormat ? {'height': '100%'} : {}" pInputText onlyNumber formControlName="assistantPhone" placeholder="Assistant Phone"/>
            </div>
          </div> 
       </div>
        <div class="header" *ngIf="showAddMore && labels_addition && labels_addition?.fields[0] && labels_addition?.fields[0].enabledInForm " >
          <h5>{{templateSections[2].name}}</h5>
      </div>
      <div class="card" *ngIf="showAddMore && labels_addition && labels_addition?.fields[0] && labels_addition?.fields[0].enabledInForm "  >
          <div class="p-field p-grid" >
              <div class="p-col-12">
                <label>{{labels_addition?.fields[0].labelName}}</label>
                <textarea pInputTextarea  formControlName='description' name="description" rows="3" ></textarea>
              </div>
          </div>
      </div>
          <app-lion-address-grid *ngIf="labels_address?.length"
          [moduleId]="contactModuleId"
          [checkedFields]="inputDataCheck"
          [addressList]="contactTempAddress"
          [countries]="countries"
          [contactListAttn]="contactListAttn"
          [selectedObjectRecord]="selectedContact"
          [states]= "states"
          [allowEdit]="mode != 'view'"
          mappingField="contactId"
          [accountAddressTypes]="accountAddressTypes"
          [addressClasses]="addressClasses"
          [fieldLabels]="labels_address"
          [firstName]="contactForm.get('firstName').value"
          [lastName]="contactForm.get('lastName').value"
          [overViewPage]="false"
          (onUpdateAddressList)="onUpdateAddressList($event)">
        </app-lion-address-grid>
        </div>

      </div>
    </form>
  </ng-container>
  <p-footer>
    <button type="button" pButton (click)="onDialogHide()" label="Cancel" class="p-button-secondary"></button>
    <button type="button" *ngIf="mode != 'view'" pButton [disabled]="mode == 'view' || isSubmitted" class="p-button-label" label="Save" (click)="onSubmit()"></button>
    <button type="button" *ngIf="mode == 'view'" [disabled]="!updateStatusId" pButton  class="p-button-label" label="Save" (click)="updateStatus()"></button>
  </p-footer>
</p-dialog>
<app-shared-manual-modal [displayPopup]="displayManualPopup"
    [colsList]="manualRuleColumnSetttings" [singleSelection]="true" [selectedObjectType]="selectedModule"
    [selectedTemplateType]="selectedTemplate" [selectedAccount]="selectedRecordList"
    (saveAssignDataclicked)="saveParentAccount($event)" (cancelClicked)="manualpopupCancelClicked()"
    (saveSettingClicked)="columnSettingSaved($event)">
</app-shared-manual-modal>
<!--  -->
<p-toast [baseZIndex]="1000000"></p-toast>